import React from 'react'
import Grid from '@material-ui/core/Grid'
import getUrl from 'front-end-core/core/url'
import Icon from 'components/shared/Icon'
import ArrowLink from 'components/redesign/ArrowLink'
import { LEGISLATION_MENU, LEGISLATION_FOLDERS } from 'constants/controllers'

export default ({ aol, query }) => (
  <div className='layout-width-constraint pt9'>
    <Grid container className='f5' alignItems='center'>
      <Grid item className='pr4'>
        <Icon name='icon-legislation' className='w7 vm' />
      </Grid>
      <Grid item className='black pr4'>
        <a className='black no-underline hover-underline' href={getUrl(LEGISLATION_FOLDERS, { aol })}>
          Legislation
        </a>
        {'\xa0 >'}
      </Grid>
      <Grid item className='dark-orchid pr6'>
        {query.name}
      </Grid>
      <Grid item>
        <div>
          <ArrowLink text='View all' textCx='pr4' url={getUrl(LEGISLATION_MENU, { aol })} />
        </div>
      </Grid>
    </Grid>
  </div>
)
